<template>
  <div class="third">
    <div class="title"></div>
    <div class="xiaozun"></div>
    <div class="No1"></div>
    <div class="jiangpai"></div>
    <div class="stars down1"></div>
    <div class="stars down2"></div>
    <div class="stars down3"></div>
    <div class="stars down4"></div>
    <div class="stars down5"></div>
    <div class="stars down6"></div>
    <div class="stars down7"></div>

    <div class="lihua"></div>


    <div class="logo"></div>
    <div class="logobg"></div>
  </div>
</template>

<script>
export default {
  name: "third.vue"
}
</script>

<style scoped>
.third .title{
  width: 468px;
  height: 82px;
  background: url("../../public/guangming_milk/title/3_title.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 54px;
  top: 5px;
  z-index: 5;
}
.third{
  width: 750px;
  /*height: 1144px;*/
  height: 1145px;
  position: relative;
  background: url("../../public/guangming_milk/3/3_bg3.jpg") no-repeat;
  background-size: 100% 100%;
}
.No1{
  width: 232px;
  height: 92px;
  position: absolute;
  background: url("../../public/guangming_milk/png/NO.1.png") no-repeat;
  background-size: 100% 100%;
  top: 397px;
  left: calc(50% - 116px);
  -webkit-animation: big 1.5s ease-in-out infinite;
  -moz-animation: big 1.5s ease-in-out infinite;
  -o-animation: big 1.5s ease-in-out infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.logobg{
  width: 245px;
  height: 245px;
  background: url("../../public/guangming_milk/3/xianggangbg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 120px;
  left: 252px;
  z-index: 5;
}
.logo{
  width: 245px;
  height: 245px;
  background: url("../../public/guangming_milk/3/xiangganglogo.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 120px;
  left: 252px;
  z-index: 6;
  -webkit-animation: big 1.5s ease-in-out infinite;
  -moz-animation: big 1.5s ease-in-out infinite;
  -o-animation: big 1.5s ease-in-out infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
@keyframes big {
  0%{
    transform: scale(1);  /*开始为原始大小*/
  }
  25%{
    transform: scale(1.1); /*放大1.1倍*/
  }
  50%{
    transform: scale(1);
  }
  75%{
    transform: scale(1.1);
  }
}
.jiangpai{
  width: 226px;
  height: 222px;
  position: absolute;
  background: url("../../public/guangming_milk/png/jiangpai2.png") no-repeat;
  background-size: 100% 100%;
  top: 905px;
  left: calc(50% - 105px);
  -webkit-animation: jp 1s ease-in-out infinite;
  -moz-animation: jp 1s ease-in-out infinite;
  -o-animation: jp 1s ease-in-out infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
@keyframes jp {
 0%{transform: translateY(0)}
 25%{transform: translateY(-5px)}
 50%{transform: translateY(0px)}
 75%{transform: translateY(5px)}
 100%{transform: translateY(0px)}
}


.third .xiaozun{
  width: 185px;
  height: 372px;
  background: url("../../public/guangming_milk/3/3_xiao.png");
  background-size: 100% 100%;
  position: absolute;
  left: calc(50% - 92.5px);
  bottom: 20px;
}

.stars{
  width: 45px;
  height: 59px;
  background: url("../../public/guangming_milk/png/stars.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;

}
.down1{
  left: 25px;
  animation: snowDown 6s linear infinite normal;
  -webkit-animation: snowDown 6s linear infinite normal;
  z-index: 15;
}
.down2{
  left: 75px;
  animation: snowDown2 5s linear infinite normal;
  -webkit-animation: snowDown2 5s linear infinite normal;
  z-index: 15;

}.down3{
  left: 225px;
  animation: snowDown3 6.2s linear infinite normal;
  -webkit-animation: snowDown3 4.2s linear infinite normal;
   z-index: 15;

 }.down4{
  left: 298px;
  animation: snowDown4 6s linear infinite normal;
  -webkit-animation: snowDown4 3.5s linear infinite normal;
     z-index: 15;
}.down5{
  left: 482px;
  animation: snowDown3 6.7s linear infinite normal;
  -webkit-animation: snowDown4 6.7s linear infinite normal;
      z-index: 15;
}.down6{
  left: 690px;
  animation: snowDown 5.9s linear infinite normal;
  -webkit-animation: snowDown 5.9s linear infinite normal;
       z-index: 15;
}.down7{
  left: 580px;
  animation: snowDown2 7.5s linear infinite normal;
  -webkit-animation: snowDown2 7.5s linear infinite normal;
        z-index: 15;
}
@keyframes snowDown {
  from {
    opacity: 1;
    top: -50px;
  }
  to {
    opacity: 1;
    top: 102%;
  }
}
@keyframes snowDown2 {
  from {
    opacity: 1;
    top: -150px;
  }
  to {
    opacity: 1;
    top: 102%;
  }
}
@keyframes snowDown3 {
  from {
    opacity: 1;
    top: -10px;
  }
  to {
    opacity: 1;
    top: 102%;
  }
}
@keyframes snowDown4 {
  from {
    opacity: 1;
    top: -90px;
  }
  to {
    opacity: 1;
    top: 102%;
  }
}

.lihua{
  width: 231px;
  height: 513px;
  background: url("../../public/guangming_milk/png/lihua.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: -10px;
  bottom: 0;
  animation: shake 3s linear infinite normal;
  -webkit-animation: shake 3s linear infinite normal;
  transform-origin: bottom right;
}
@-webkit-keyframes shake {
  10% {
    transform: rotate(5deg);
  }
  20% {
    transform: rotate(-5deg);
  }
  30% {
    transform: rotate(5deg);
  }
  40% {
    transform: rotate(-5deg);
  }
  50%,
  100% {
    transform: rotate(0deg);
  }
}
</style>
